import { useTranslate } from '../../TranslationsContext'
import { Button } from '../Button/Button'
import { Container } from '../Container/Container'
import photo1 from '../../assets/ceramol-acne-acne-in-eta-adulta.jpg'
import photo2 from '../../assets/ceramol-acne-i-falsi-miti-da-sfatare.jpg'
import './Articles.css'
import { Heading } from '../Heading/Heading'

export function Articles() {
  const translate = useTranslate()
  const firstTitle = translate('Article.1.title')

  return firstTitle !== 'Article.1.title' ? (
    <div className="Articles">
      <Container>
        <div className="sections">
          <div className="section">
            <div
              className="cta"
              onClick={() => window.open(translate('Article.1.url'), '_blank')}
            >
              <img src={photo1} alt={translate('Article.1.title')} />
              <Heading type="Section">{translate('Article.1.title')}</Heading>
            </div>
            <Button
              type="Link"
              url={translate('Article.1.url')}
              label={translate('Article.1.cta')}
              target="_blank"
              rel="nofollow"
            />
          </div>
          <div className="section">
            <div
              className="cta"
              onClick={() => window.open(translate('Article.2.url'), '_blank')}
            >
              <img src={photo2} alt={translate('Article.2.title')} />
              <Heading type="Section">{translate('Article.2.title')}</Heading>
            </div>
            <Button
              type="Link"
              url={translate('Article.2.url')}
              label={translate('Article.2.cta')}
              target="_blank"
              rel="nofollow"
            />
          </div>
        </div>
      </Container>
    </div>
  ) : null
}
